// @ts-expect-error странные d.ts
import { MemoryStorage, WebStorage } from 'vue-ls/src/storage';
import type { App } from 'vue';

export interface LocalStorage {
    length: number;
    options: LocalStorageOptions;
    get(name: string, def?: any): any;
    set(name: string, value: any, expire?: number): void;
    key(index: number): string | null;
    remove(name: string): void;
    clear(): void;
    on(name: string, callback: () => void): void;
    off(name: string, callback: () => void): void;
    setOptions(options?: LocalStorageOptions): void;
}

export interface LocalStorageOptions {
    namespace?: string | undefined;
    name?: string | undefined;
    storage?: 'session' | 'local' | 'memory';
}

let ls: LocalStorage;

// eslint-disable-next-line
const _global = typeof window !== 'undefined' ? window : global || {}

export function useLs() {
  if (!ls) {
    throw new Error('vue-ls not initialized');
  }

  const result = {
    ...ls,
    /**
     * @deprecated переход более простой формат
     */
    ls,
  };

  Object.setPrototypeOf(result, ls);

  return result;
}

/**
 * @type {import('vue').Plugin}
 */
const VueStorage = {
  install(app: App<Element>, options: LocalStorageOptions = {}) {
    const _options = Object.assign({}, options, {
      storage: options.storage || 'local',
      name: options.name || 'ls',
    });

    if (
      _options.storage &&
      ['memory', 'local', 'session'].indexOf(_options.storage) === -1
    ) {
      throw new Error(`Vue-ls: Storage "${_options.storage}" is not supported`);
    }

    let store = null;

    switch (_options.storage) {
      case 'local':
        store = 'localStorage' in _global ? _global.localStorage : null;
        break;

      case 'session':
        store = 'sessionStorage' in _global ? _global.sessionStorage : null;
        break;
      case 'memory':
        store = MemoryStorage;
        break;
    }

    if (!store) {
      store = MemoryStorage;
      console.error(
        `Vue-ls: Storage "${_options.storage}" is not supported your system, use memory storage`,
      );
    }

    ls = new WebStorage(store);

    ls.setOptions(
      Object.assign(
        ls.options,
        {
          namespace: '',
        },
        _options || {},
      ),
    );

    app.config.globalProperties[`$${_options.name}`] = ls;
  },
};

export default VueStorage;